// @flow
import CashBox from './CashBox';

export default CashBox;
